import {Collection} from "backbone";
import CompanyLocationModel from "../model/CompanyLocationModel";

const CompanyLocationCollection = Collection.extend({

    model: CompanyLocationModel

});

export default CompanyLocationCollection;